import Form from '../form/Form';
import {h} from 'preact';
import FieldGroup from '../form/FieldGroup';
import {useCallback, useEffect} from 'preact/hooks';
import Button from '../form/Button';
import {CommandStatus} from '../../../../framework/type';
import useCommandErrors from '../../../../framework/hook/useCommandErrors';
import commandsAreRunning from '../../../../framework/commandsAreRunning';
import {Job} from '../../model/Job';
import Paragraph from '../media/Paragraph';
import currentUserTeam from '../../query/currentUserTeam';
import {useUnarchiveJobsCommand} from '../../command/unarchiveJobs';

interface Props {
  jobs: Job[];
  onCancel(): void;
  onSuccess(): void;
}

export default function UnarchiveJobsForm({jobs, onCancel, onSuccess}: Props) {
  const team = currentUserTeam();

  const [command, unarchiveJobs] = useUnarchiveJobsCommand();
  const {system} = useCommandErrors(command);
  const isLoading = commandsAreRunning(command);

  const submit = useCallback(() => {
    if (jobs.length === 0 || isLoading || !team) return;

    unarchiveJobs({
      teamId: team.id,
      jobIds: jobs.map(job => job.id)
    })
  }, [jobs, team, isLoading, unarchiveJobs]);

  useEffect(() => {
    if (!command || command.status !== CommandStatus.SUCCESS) return;
    onSuccess();
  }, [command]);

  return (
    <Form heading="Unarchive Jobs" onSubmit={submit} error={system}>
      <Paragraph>This will unarchive the following jobs:</Paragraph>
      <ul>
        {jobs.map(job => (
          <li>{job.name}</li>
        ))}
      </ul>
      <FieldGroup horizontal={true}>
        <Button primary={true} type="submit" disabled={isLoading} onClick={submit}>Unarchive</Button>
        <Button type="cancel" onClick={onCancel}>Cancel</Button>
      </FieldGroup>
    </Form>
  )
}